<!--<c-footer>-->
  <div class="ms-auto">
    <a href="#" target="_blank">Remote Sign</a>
    <span> &copy; 2024 ubiquio</span>
  </div>
  
<!--</c-footer>-->
